import React from "react";
import {
  Box,
  Heading,
  Text,
  Center,
  Icon,
  Button,
  SimpleGrid,
  Divider,
  useColorModeValue,
} from "@chakra-ui/react";
import { PiInvoice } from "react-icons/pi";

const Billing = () => {
  // -----------------------------
  // 1) (No local state)
  // -----------------------------

  // -----------------------------
  // 2) Color definitions
  // -----------------------------
  const containerBg = useColorModeValue("gray.50", "gray.800");
  const headingColor = useColorModeValue("primary.700", "primary.500");
  const iconColor = useColorModeValue("primary.500", "primary.500");
  const textColor = useColorModeValue("gray.600", "gray.200");
  const subHeadingColor = useColorModeValue("primary.600", "primary.500");
  const dividerColor = useColorModeValue("gray.200", "gray.600");

  // -----------------------------
  // 3) JSX
  // -----------------------------
  return (
    <Box
      bg={containerBg}
      w="100%"
      minH="100vh"
      p={5}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <Center w="100%" flexDirection="column">
        <Icon as={PiInvoice} boxSize={20} color={iconColor} mb={4} />
        <Heading as="h1" size="2xl" color={headingColor} textAlign="center">
          Billing Module Coming Soon
        </Heading>
        <Text
          fontSize="lg"
          color={textColor}
          textAlign="center"
          maxW="800px"
          mt={4}
        >
          We&apos;re excited to announce that our new Billing Module is on the
          way! Soon, you&apos;ll be able to manage all your invoices, payments,
          and financial reports directly from your client portal.
        </Text>
        <Button colorScheme="primary" size="lg" mt={6} disabled>
          Notify Me When Available
        </Button>
      </Center>

      <Divider my={10} borderColor={dividerColor} />

      {/* Feature Highlights */}
      <Box maxW="800px" mx="auto">
        <Heading
          as="h2"
          size="lg"
          color={subHeadingColor}
          mb={4}
          textAlign="center"
        >
          Upcoming Features
        </Heading>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
          <Box>
            <Heading as="h3" size="md" mb={2} color={textColor}>
              💳 Online Payments
            </Heading>
            <Text color={textColor}>
              Accept credit card payments directly through the portal with
              secure payment processing.
            </Text>
          </Box>
          <Box>
            <Heading as="h3" size="md" mb={2} color={textColor}>
              🧾 Invoice Management
            </Heading>
            <Text color={textColor}>
              Create, send, and track invoices with ease. Customize invoice to
              match your branding.
            </Text>
          </Box>
          <Box>
            <Heading as="h3" size="md" mb={2} color={textColor}>
              📊 Financial Reports
            </Heading>
            <Text color={textColor}>
              Generate detailed financial reports to monitor revenue, expenses,
              and profitability.
            </Text>
          </Box>
          <Box>
            <Heading as="h3" size="md" mb={2} color={textColor}>
              ⏱️ Time Tracking Integration
            </Heading>
            <Text color={textColor}>
              Integrate time tracking data to automatically calculate billable
              hours and costs.
            </Text>
          </Box>
        </SimpleGrid>
      </Box>
      <Box w="10px" h="100px" />
    </Box>
  );
};

export default Billing;
